var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [{
      action: true
    }, {
      none_border_bottom: _vm.btnone
    }]
  }, [_c('Button', {
    staticClass: "back",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v($t("oxvu2", "返回"))]), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text || $t("e5xl2", "使用")))]), _c('span', [_vm._t("default")], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };